(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const roots = document.querySelectorAll('.mizumi');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.hasAttribute('data-mizumi-init')) return;
      root.setAttribute('data-mizumi-init', 'true');

      initScrollReveal(root);
      initFaq(root);
      const getSubscription = initSubscriptionToggle(root);
      initQuantityStepper(root);
      initAddToCart(root, getSubscription);
      initMarqueeSafety(root);
    });
  }

  function initScrollReveal(root) {
    const targets = root.querySelectorAll('.mizumi-reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  }

  function initFaq(root) {
    const items = root.querySelectorAll('.mizumi-faq-item');
    if (!items.length) return;

    items.forEach((item) => {
      const btn = item.querySelector('.mizumi-faq-q');
      if (!btn) return;

      btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = item.classList.contains('open');

        items.forEach((other) => {
          if (other !== item && other.classList.contains('open')) {
            other.classList.remove('open');
            const otherBtn = other.querySelector('.mizumi-faq-q');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initSubscriptionToggle(root) {
    const state = { subscription: false };
    const groups = root.querySelectorAll('.mizumi-subscription-toggle');
    const priceOnetimeEl = root.querySelector('[data-mizumi-price-onetime]');
    const priceSubEl = root.querySelector('[data-mizumi-price-sub]');

    groups.forEach((group) => {
      const buttons = group.querySelectorAll('.mizumi-toggle-btn');
      const activeInitial = group.querySelector('.mizumi-toggle-btn.active');
      if (activeInitial?.dataset.mizumiToggle === 'subscribe') {
        state.subscription = true;
      }

      applyPriceVisibility(state.subscription, priceOnetimeEl, priceSubEl);

      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          buttons.forEach((sib) => sib.classList.remove('active'));
          btn.classList.add('active');

          const toggleValue = btn.dataset.mizumiToggle;
          state.subscription = toggleValue === 'subscribe';

          applyPriceVisibility(state.subscription, priceOnetimeEl, priceSubEl);
        });
      });
    });

    return () => state.subscription;
  }

  function applyPriceVisibility(isSubscription, onetimeEl, subEl) {
    if (!onetimeEl || !subEl) return;
    if (isSubscription) {
      onetimeEl.hidden = true;
      subEl.hidden = false;
    } else {
      onetimeEl.hidden = false;
      subEl.hidden = true;
    }
  }

  function initQuantityStepper(root) {
    const inputs = root.querySelectorAll('[data-mizumi-qty-input]');
    if (!inputs.length) return;

    inputs.forEach((input) => {
      const container = input.closest('.mizumi-qty-selector, .mizumi-qty-row, .mizumi-qty') || input.parentElement;
      if (!container) return;

      const buttons = container.querySelectorAll('[data-mizumi-qty]');
      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const action = btn.dataset.mizumiQty;
          const current = parseInt(input.value, 10) || 1;
          let next = current;
          if (action === 'plus') next = Math.min(99, current + 1);
          else if (action === 'minus') next = Math.max(1, current - 1);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initAddToCart(root, getSubscription) {
    const buttons = root.querySelectorAll('[data-mizumi-add-to-cart]');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.disabled) return;

        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const qtyInput = root.querySelector('[data-mizumi-qty-input]');
        const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        const subscription = typeof getSubscription === 'function' ? getSubscription() : false;

        const originalText = btn.textContent;
        const originalBg = btn.style.background;
        btn.disabled = true;

        const payload = {
          id: variantId,
          quantity,
          properties: { _subscription: subscription ? 'true' : 'false' },
        };

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload),
          });

          if (!res.ok) throw new Error(`cart/add failed: ${res.status}`);
          await res.json();

          btn.textContent = '✓ ADDED TO BAG 💖';
          btn.style.background = '#22c55e';

          try {
            const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            if (cartRes.ok) {
              const cart = await cartRes.json();
              document.querySelectorAll('[data-cart-count]').forEach((el) => {
                el.textContent = cart.item_count;
              });
            }
          } catch (err) {
            console.error('mizumi: cart refresh failed', err);
          }

          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = originalBg;
            btn.disabled = false;
          }, 2200);
        } catch (err) {
          console.error('mizumi: add to cart failed', err);
          btn.textContent = "couldn't add — try again";
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = originalBg;
            btn.disabled = false;
          }, 2200);
        }
      });
    });
  }

  function initMarqueeSafety(root) {
    const marquees = root.querySelectorAll('.mizumi-marquee-inner');
    marquees.forEach((inner) => {
      const parent = inner.parentElement;
      if (!parent) return;
      const children = Array.from(inner.children);
      if (!children.length) return;

      const contentWidth = children.reduce((sum, child) => sum + child.getBoundingClientRect().width, 0);
      const containerWidth = parent.getBoundingClientRect().width;

      if (contentWidth > 0 && contentWidth < containerWidth) {
        children.forEach((child) => {
          inner.appendChild(child.cloneNode(true));
        });
      }
    });
  }

  // Mobile testimonial swipe: handled by CSS scroll-snap-type on .mizumi-testimonials-grid.
})();
